import { defineMessages } from 'react-intl';
export default defineMessages({
  close: {
    id: 'widget.header.close',
    defaultMessage: 'Close'
  },
  open: {
    id: 'widget.header.open',
    defaultMessage: 'Open'
  },
  openOutside: {
    id: 'widget.header.openOutside',
    defaultMessage: 'Open in new window'
  },
  print: {
    id: 'widget.header.print',
    defaultMessage: 'Print'
  },
  fax: {
    id: 'widget.header.fax',
    defaultMessage: 'Fax'
  },
  removeWidget: {
    id: 'widget.header.removeWidget',
    defaultMessage: 'Remove widget'
  },
  hideWidgetConfirm: {
    id: 'widget.header.hideWidgetConfirm',
    defaultMessage: 'Hide widget?'
  },
  hideWidget: {
    id: 'widget.header.hideWidget',
    defaultMessage: 'Hide'
  },
  cancel: {
    id: 'widget.header.cancel',
    defaultMessage: 'Cancel'
  }
});